import React from 'react';
import { Box, FormLabel, Stack, TextField, Typography } from '@mui/material';

/**
 * Label + Input field used across brand settings. Keeps the prop shape
 * (mb, isRequired, isInvalid, errorText, extra) so existing call sites
 * compile unchanged.
 */
export default function Default(props) {
  const {
    id,
    name,
    label,
    extra,
    placeholder,
    type,
    mb,
    value,
    onChange,
    onBlur,
    isRequired,
    isInvalid,
    errorText,
    me, // legacy spacing prop — ignored
    ...rest
  } = props;

  return (
    <Stack direction='column' sx={{ mb: mb ?? '30px', width: '100%' }}>
      {label && (
        <FormLabel
          htmlFor={id}
          sx={{
            display: 'flex',
            ml: '10px',
            fontSize: '0.875rem',
            fontWeight: 700,
            color: 'text.primary',
            cursor: 'pointer',
            mb: '6px',
          }}
        >
          {label}
          {isRequired && (
            <Box component='span' sx={{ color: 'error.main', ml: '4px' }}>*</Box>
          )}
          {extra && (
            <Typography variant='body2' fontWeight='400' ml='2px'>
              {extra}
            </Typography>
          )}
        </FormLabel>
      )}
      <TextField
        id={id}
        name={name}
        type={type || 'text'}
        placeholder={placeholder}
        value={value ?? ''}
        onChange={onChange}
        onBlur={onBlur}
        error={!!isInvalid}
        size='small'
        fullWidth
        inputProps={{ 'aria-invalid': isInvalid ? 'true' : undefined }}
        sx={{ '& .MuiInputBase-root': { height: 44 } }}
        {...rest}
      />
      {isInvalid && errorText && (
        <Typography variant='caption' color='error.main' sx={{ ml: '10px', mt: '6px' }}>
          {errorText}
        </Typography>
      )}
    </Stack>
  );
}
